import { Routes, Route } from 'react-router-dom'
import DashboardLayout from './layouts/DashboardLayout'
import AdMobRevenue from './pages/AdMobRevenue'
import AppAnalytics from './pages/AppAnalytics'
import UserMetrics from './pages/UserMetrics'
import { RetentionAnalytics } from './pages/RetentionAnalytics'

function App() {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<AdMobRevenue />} />
        <Route path="admob" element={<AdMobRevenue />} />
        <Route path="analytics" element={<AppAnalytics />} />
        <Route path="metrics" element={<UserMetrics />} />
        <Route path="retention" element={<RetentionAnalytics />} />
      </Route>
    </Routes>
  )
}

export default App
